import styled from 'styled-components';
const Subsection = styled.div`
  margin: -20px -20px 0 -20px;
  min-height: 100vh;
  background-color: rgb(243, 242, 241);
`;
export default Subsection;